<template>
  <div class="boederRadius-conatiner" ref="borderRadius">
    <div class="border-radius-header mb12">
      <span class="verticallyCenter"
        >{{ borderRadiusName }}
        <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
      </span>
      <div class="border-radius-btn">
        <el-tooltip class="item" effect="dark" content="全部圆角" placement="top-end" :open-delay="1000">
          <span :class="borderTypeFlagVal == 2 ? 'select' : ''" @click="changeBorderRadiusType(2)"
            ><i class="icon-portal-adjustment1"></i
          ></span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="独立圆角" placement="top-end" :open-delay="1000">
          <span :class="borderTypeFlagVal == 1 ? 'select' : ''" @click="changeBorderRadiusType(1)"
            ><i class="icon-portal-full-screen1"></i
          ></span>
        </el-tooltip>
      </div>
    </div>
    <div v-if="borderTypeFlagVal == 1">
      <slider-and-input
        :value.sync="borderTopLeftRadiusVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        :className="request_prefix === 'bigScreen' ? 'radius_bg_1' : 'home_radius bg_1'"
        inputWidth="small"
        inputHeight="small"
        tips="左上圆角"
      />
      <slider-and-input
        :value.sync="borderTopRightRadiusVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        :className="request_prefix === 'bigScreen' ? 'radius_bg_2' : 'home_radius bg_2'"
        inputWidth="small"
        inputHeight="small"
        tips="右上圆角"
      />
      <slider-and-input
        :value.sync="borderBottomRightRadiusVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        :className="request_prefix === 'bigScreen' ? 'radius_bg_3' : 'home_radius bg_3'"
        inputWidth="small"
        inputHeight="small"
        tips="右下圆角"
      />
      <slider-and-input
        :value.sync="borderBottomLeftRadiusVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        :className="request_prefix === 'bigScreen' ? 'radius_bg_4' : 'home_radius bg_4'"
        inputWidth="small"
        inputHeight="small"
        tips="左下圆角"
      />
    </div>
    <div v-else class="verticallyCenter">
      <slider-and-input
        :value.sync="borderRadiusVal"
        :sliderMax="sliderMax"
        suffix="px"
        inputWidth="small"
        inputHeight="small"
      />
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>圆角是指用一段与角的两边相切的圆弧来替换原来的角：</span
        >圆角的大小可以四个角一起设置，也可以每个角单独设置；圆角的值不允许为负数。
      </p>
      <div class="box"><video src="../../assets/images/tipsVideoImg/border-radio.mp4" controls></video></div>
    </el-dialog>
  </div>
</template>

<script>
import { withMethodsHistoryCombine, historyIgnoreWrap } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "borderRadius",
  props: {
    borderTypeFlag: {
      default: 1,
      required: false
    },
    borderRadiusName: {
      default: "圆角",
      required: false
    },
    borderRadius: {
      default: undefined,
      type: [Array, String, Number], // 颜色有字符串和null的情况
      required: false
    },
    borderTopLeftRadius: {
      type: [String, Number],
      required: true
    },
    borderTopRightRadius: {
      type: [String, Number],
      required: true
    },
    borderBottomRightRadius: {
      type: [String, Number],
      required: true
    },
    borderBottomLeftRadius: {
      type: [String, Number],
      required: true
    },
    sliderMax: {
      default: 500,
      required: false
    },
    changeBorderRadiusTypeFunc: {
      type: Function
    }
  },
  data() {
    return {
      this1: this,
      explainDialog: false
    }
  },
  watch: {
    "$store.state.states.activeID": {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.$nextTick(() => {
          historyIgnoreWrap(() => {
            if (
              this.borderTopLeftRadiusVal === this.borderTopRightRadiusVal &&
              this.borderTopLeftRadiusVal === this.borderBottomRightRadiusVal &&
              this.borderTopLeftRadiusVal === this.borderBottomLeftRadiusVal &&
              this.borderTypeFlagVal !== 2
            ) {
              this.borderRadiusVal = this.borderTopLeftRadiusVal
              this.borderTypeFlagVal = 2
            }
          })()
        })
      }
    }
  },
  computed: {
    borderTypeFlagVal: {
      get() {
        return this.borderTypeFlag
      },
      set(val) {
        this.$emit("update:borderTypeFlag", val)
      }
    },
    borderRadiusVal: {
      get() {
        return this.borderRadius
      },
      set(val) {
        this.$emit("update:borderRadius", val)
      }
    },
    borderTopLeftRadiusVal: {
      get() {
        return this.borderTopLeftRadius
      },
      set(val) {
        this.$emit("update:borderTopLeftRadius", val)
      }
    },
    borderTopRightRadiusVal: {
      get() {
        return this.borderTopRightRadius
      },
      set(val) {
        this.$emit("update:borderTopRightRadius", val)
      }
    },
    borderBottomRightRadiusVal: {
      get() {
        return this.borderBottomRightRadius
      },
      set(val) {
        this.$emit("update:borderBottomRightRadius", val)
      }
    },
    borderBottomLeftRadiusVal: {
      get() {
        return this.borderBottomLeftRadius
      },
      set(val) {
        this.$emit("update:borderBottomLeftRadius", val)
      }
    }
  },
  methods: {
    changeBorderRadiusType(value) {
      if (this.borderTypeFlagVal === value) {
        return
      }
      if (this.changeBorderRadiusTypeFunc && typeof this.changeBorderRadiusTypeFunc == "function") {
        this.changeBorderRadiusTypeFunc(value)
        return
      }
      if (value === 2) {
        this.borderRadiusVal = this.borderTopLeftRadiusVal
      }
      this.borderTypeFlagVal = value
    }
  }
})
</script>

<style scoped lang="scss">
.boederRadius-conatiner {
  position: relative;
}
.boederRadius-wrap {
  position: absolute;
  padding: 18px;
  width: 252px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  z-index: 10;
}
.w100_40 {
  width: calc(100% - 36px);
}
.color-picker-container:hover .bind-icon {
  display: inline-block;
}
.color-picker-container .bind-icon {
  display: none;
  position: absolute;
  right: 6px;
  top: 4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  text-align: center;
  font-size: 24px;
  cursor: pointer;
  overflow: hidden;
}
.color-picker-container .bind-icon:visited,
.color-picker-container .bind-icon:active {
  background-color: transparent;
}
.color-picker-container .color-text {
  width: calc(100% - 40px);
}
::v-deep .el-color-picker__mask {
  width: 20px;
  height: 20px;
  background-color: transparent;
}
::v-deep .el-color-picker.is-disabled .el-color-picker__color {
  border-radius: 50%;
  overflow: hidden;
}
.boederRadius-list {
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 8px;
  position: relative;
  > li:not(:last-child) {
    margin-bottom: 8px;
  }
  > li {
    background: var(--cardBgColor);
    position: relative;
    height: 32px;
    border-radius: 4px;
    padding: 6px;
    &:hover {
      .right-handle-icon {
        display: inline-block;
      }
    }
    &.active {
      border-color: var(--themeColor);
    }
  }
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
  }
  .delete-boederRadius {
    font-size: 14px;
  }
}
.border-radius-header .tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.border-radius-header .tips-btn:hover {
  color: var(--themeColor);
}
::v-deep .explainDialog {
  width: 700px;
}
::v-deep .explainDialog .el-dialog__body {
  padding: 16px 24px 24px;
  color: var(--textColor);
}

::v-deep .explainDialog .tips span {
  font-weight: 600;
}

::v-deep .explainDialog .box {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  height: 366px;
  background: #fafafa;
  margin-top: 16px;
}
</style>
